import React from "react";
import "../style.css";

const Process: React.FC = () => {
  return (
    <div id="processes" className="processesPage">
      <div className="process-grid-container">
        <div className="processHeader">
          <div
            className="process-hero"
            style={{
              backgroundImage:
                "url('/images/gallery/TapewormDisassembled.jpg')",
            }}
          >
            <div className="processHeaderDescription">
              <h6>How We Build It</h6>
              <h3 className="process-hero-heading">Meet Our</h3>
              <h3 className="process-hero-heading process-hero-heading--accent">
                Sub-Teams
              </h3>
            </div>
          </div>

          <p className="goalDescription">
            Our Goal: At SURF we are trying our best to make a working and
            reliable underwater autonomous vehicle
          </p>

          <div className="process-grid-box">
            <ElectricalProcess />
            <SoftwareProcess />
            <MechanicalProcess />
          </div>
        </div>
      </div>
    </div>
  );
};

const ElectricalProcess = () => {
  return (
    <div className="Electrical_Process">
      <div className="Flexbox_Container">
        <div className="Electrical_Description">
          <h3>Electrical Team</h3>
          <hr />
          <p>
            This year the surf electrical team is working on a complete redesign
            of the sub's electronics. We are creating several new PCB boards.
            The different boards all serve different functions. First, we are
            designing the circuits in an Electronic Design Automation software
            (EDA). We simulate the circuit in a spice simulator. Second, we go
            through the circuit and start selecting parts and Integrated
            Circuits (ICs). This can be the most time intensive part of the
            process. We pour over datasheets, comparing requirements, and
            changing our designs to make it more practical and efficient.
            Finally, we build a 3D model of the circuit board. This part
            requires a lot of planning and revision. A lot of factors go into a
            good design. All of these tasks are not taught in the Electrical
            Engineering program and require us to research and learn on our own.
          </p>
        </div>
        <div className="Electrical_Content">
          <img
            src="/images/gallery/ElectricalContent1.jpg"
            alt="Electrical team PCB work"
          />
        </div>
      </div>
    </div>
  );
};

const SoftwareProcess = () => {
  return (
    <div className="Software_Process">
      <div className="Flexbox_Container">
        <div className="Software_Description">
          <h3>Software Team</h3>
          <hr />
          <p>
            The software team's main responsibility is making the sub able to
            navigate an underwater obstacle course autonomously. We seek to
            accomplish this task by using a combination of sensor data and
            machine learning. We use machine learning to help us find objects
            and choose what the agenda is dynamically based on the bot's
            proximity to tasks. The software team also works closely with both
            the mechanical and electrical team members to design and integrate
            new parts and systems into the sub. These additions then allow the
            bot to tackle new tasks such as manipulating shells with a grasper
            of some kind.
          </p>
        </div>
        <div className="Software_Content">
          <img
            src="/images/gallery/SURF2025_StateMachine-Main_State_Machine.drawio_1.png"
            alt="Software team state machine diagram"
          />
        </div>
      </div>
    </div>
  );
};

const MechanicalProcess = () => {
  return (
    <div className="Mechanical_Process">
      <div className="Flexbox_Container">
        <div className="Mechanical_Description">
          <h3>Mechanical Team</h3>
          <hr />
          <p>
            The mechanical team designs and fabricates the sub's entire physical
            structure from scratch. Our process begins in SolidWorks, where we
            model components, run interference checks, and generate
            manufacturing drawings before a single part is cut or printed. We
            machine aluminum and acrylic in the College of Engineering's machine
            shop and use FDM 3D printing for complex geometries like thruster
            mounts and camera housings.
            <br />
            <br />
            Buoyancy management is a constant design constraint: competition
            rules require the vehicle to be net-positive buoyant by at least
            0.5% of their weight. We track mass and volume in a running
            spreadsheet that feeds directly into design decisions at every
            revision.
            <br />
            <br />
            This year, the team is developing new torpedo launchers and a
            grabber mechanism to expand the number of tasks completable at
            RoboSub. We use SolidWorks Flow Simulation CFD to characterize
            torpedo drag and size the spring ejection system before committing
            to physical prototypes.
          </p>
        </div>
        <div className="Mechanical_Content">
          <img
            src="/images/gallery/TapewormModelVertical.png"
            alt="3D model of the Tapeworm submarine"
          />
        </div>
      </div>
    </div>
  );
};

export default Process;
